<template>
    <div class="container-fluid">
        <div class="row">
            <div class="d-flex col-sm justify-content-center">
                <h2>Kontakt</h2>
            </div>
        </div>
<!--        <div class="row">-->
<!--            <div class="d-flex col-sm justify-content-center">-->
<!--                <p>Pořádáme večírky</p>-->
<!--            </div>-->
<!--        </div>-->
        <div class="d-flex justify-content-center">
            <div class="row">
                <div class="col-sm">
                    <h4>Telefon</h4>
                    <p><a href="tel:724 006 627">724 006 627</a></p>
                    <p><a href="tel:777 140 001">777 140 001</a></p>
                </div>
                <div class="col-sm">
                    <h4>E-mail</h4>
                    <p><a href="mailto:kontakt@hradnisklipek.eu">kontakt@hradnisklipek.eu</a></p>
                    <p><a href="mailto:rezervace@hradnisklipek.eu">rezervace@hradnisklipek.eu</a></p>
                </div>
                <div class="col-sm">
                    <h4>Adresa</h4>
                    <p>Hrad, 2. Nádvoří, Strakonice</p>
                </div>
            </div>
        </div>
        <div style="width: 100%">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d650.9923751199661!2d13.900912829258637!3d49.25802399870805!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470b35b2c112ac97%3A0x277449653b2796d6!2zVmluw6FybmEgSHJhZG7DrSBTa2zDrXBlaw!5e0!3m2!1scs!2scz!4v1580151717721!5m2!1scs!2scz"
                    width="100%" height="400" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
        </div>
    </div>
</template>

<script>
    // eslint-disable-next-line no-unused-vars
    var _ = require('lodash');
    // eslint-disable-next-line no-unused-vars
    const axios = require('axios');


    export default {
        name: 'contact',
        components: {
            // OpeningTime
        }
    }
</script>

<style>
</style>
